import React, { Component } from "react";
// import Immutable from "immutable";
import { withStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
// import clsx from "clsx";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import i18n from "helpers/i18n";
import Grid from "@material-ui/core/Grid";
const styles = (theme) => {
  // console.log(theme)
  return {
    root: {
      position: "fixed",
      width: "100%",
      bottom: 0,
      left: 0,
      color: theme.palette.rgpd && theme.palette.rgpd.color ? theme.palette.rgpd.color :  theme.palette.primary.main,
      backgroundColor: theme.palette.rgpd && theme.palette.rgpd.backgroundColor ? theme.palette.rgpd.backgroundColor :  theme.palette.primary.main,
      boxShadow: theme.shadows[8],
      zIndex: 9999,
      "& .MuiTypography-body1": {
        fontSize: "1.2rem",
        paddingRight: theme.spacing(0),
        paddingLeft: theme.spacing(0),
        '& a': {
          color: theme.palette.rgpd && theme.palette.rgpd.color ? theme.palette.rgpd.color :  theme.palette.primary.main,
        }
      },
      /*
      "& .MuiButton-outlinedSecondary": {
        backgroundColor: theme.palette.rgpd && theme.palette.rgpd.buttonBackgroundColor ? theme.palette.rgpd.buttonBackgroundColor : theme.palette.background.default,
        fontSize: "1.1rem",
        [theme.breakpoints.down("md")]: {
          marginTop: theme.spacing(2),
        },
      },
      */
    },
  };
};
class RGPDBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
    };
  }
  componentDidMount() {
    try {
      const cookieStr = this._getCookie("rgpd");
      const cookie = JSON.parse(cookieStr);
      if (cookie !== undefined && cookie.rgpd === true)
        this.setState({ show: false });
    } catch (e) {}
  }
  _getCookie = (cname) => {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };

  _accept = () => {
    // document.cookie = JSON.stringify({ rgpd: true });
    const d = new Date();
    const exdays = 10;
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie =
      "rgpd=" + JSON.stringify({ rgpd: true }) + ";" + expires + ";path=/";

    this.setState({ show: false });
  };
  render() {
    const { classes } = this.props;
    const { show } = this.state;
    return (
      <If condition={show === true}>
        <div className={classes.root}>
          <Box width="100%" p={4}>
            <Grid container alignItems="center" justify="center">
              <Grid item xs={12} md={10}>
                <Typography variant="body1">
                  {i18n.get("rgpdPopin", { pretty: true })}
                </Typography>
              </Grid>
              <Grid item xs={12} md={2} container justify="center">
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  onClick={this._accept}
                >
                  {i18n.get("rgpdAccept")}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </div>
      </If>
    );
  }
}
// export default ;
export default withStyles(styles)(RGPDBanner);



// WEBPACK FOOTER //
// ./src/components/UI/RGPDBanner/RGPDBanner.jsx